import { render, staticRenderFns } from "./HuPrivacyPolicy.vue?vue&type=template&id=6c424cb7&scoped=true"
import script from "./HuPrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./HuPrivacyPolicy.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "6c424cb7",
  null
  ,true
)

export default component.exports